import React, { useState, useEffect } from "react";
import axios from "axios";
import Slider from "react-slick";
import { v4 as uuidv4 } from "uuid";
import ProductCard from "./ProductCard";
import "../styles/HomePage.css";


const AdditionalCarousel = ({ categoryId, categoryName, cart, setCart, guestCartId, isLoggedIn }) => {
  const [products, setProducts] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchProductsByCategory = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/products/category/${categoryId}`
        );
        setProducts(response.data.slice(0, 5)); // Limit to 5 products
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProductsByCategory();
  }, [categoryId]);

  const fetchCartItems = () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const guestCartId = localStorage.getItem("guestCartId");

    const cartIdentifier = userId
      ? `userId=${userId}`
      : `guestCartId=${guestCartId}`;

    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

    axios
      .get(`${API_BASE_URL}/cart?${cartIdentifier}`, config)
      .then((response) => {
        setCart(response.data.items);
      })
      .catch((error) => {
        console.error("Error fetching cart items:", error);
      });
  };

  const addToCart = (product) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    let guestCartId = localStorage.getItem("guestCartId");

    const price = product.onSale
      ? product.price * (1 - product.discountPercentage / 100)
      : product.price;

    if (!isLoggedIn && !guestCartId) {
      const newGuestCartId = uuidv4();
      localStorage.setItem("guestCartId", newGuestCartId);
      guestCartId = newGuestCartId;
    }

    const payload = isLoggedIn
      ? { productId: product.id, quantity: 1, userId, price }
      : { productId: product.id, quantity: 1, guestCartId, price };

    fetch(`${API_BASE_URL}/cart/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? "Bearer " + token : "",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to add to cart");
        fetchCartItems();
        alert("Product added to cart!");
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
        alert("Error adding item to cart: " + error.message);
      });
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: products.length > 5,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="product-carousel">
      <h2>{categoryName || "Loading..."}</h2>
      {products.length > 0 ? (
        <Slider {...settings}>
          {products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={() => addToCart(product)}
            />
          ))}
        </Slider>
      ) : (
        <p>No products available in this category.</p>
      )}
    </div>
  );
};

export default AdditionalCarousel;